import React from 'react';
import { M131ProductDetailModule } from '~/lib/data-contract';
import { ModuleFeatureContext } from '~/templates/blocks/context/ModuleFeatureContext';
import ProductDetails from './product-details.component';

const M131ProductDetail = (props: M131ProductDetailModule) => {
    return (
        <ModuleFeatureContext.Provider value={{ reserveInStore: true }}>
            <ProductDetails {...props} />
        </ModuleFeatureContext.Provider>
    );
};

export default M131ProductDetail;
